const React = require('react')
const { useState, useEffect } = require('react')
const { useParams } = require('react-router-dom')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { TableHeader, TableFooterWithoutLimit } = require('@components/table')

const { TokenInventoryTable } = require('./inventoryTable.token')

require('@styles/pages/address/transactions.address.css')

const TokenInventory = props => {
    const { setActiveTab } = props
    const { address } = useParams()
    const { network } = useNetworkConfig()
    const params = new URLSearchParams(location.search)

    const { getTokenInventory } = useBlockchainData(network.name)

    const [loading, setLoading] = useState(false)
    const [tokenInventoryData, setTokenInventoryData] = useState()
    const [userAddress, setUserAddress] = useState(params.get('a') ? params.get('a').toLowerCase() : null)
    const [page, setPage] = useState(Number(params.get('p')) || 1)

    const [totalPages, setTotalPages] = useState(0)

    const [title, setTitle] = useState()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const pageParam = Number(params.get('p'))
        const userAddressParam = params.get('a') ? params.get('a').toLowerCase() : null

        if (userAddressParam && userAddressParam !== address) {
            setUserAddress(userAddressParam)
        }

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)

                const [tokenInventoryResponse] = await Promise.all([
                    getTokenInventory(page, 25, {
                        ...(address && { address }),
                        ...(userAddress && { userAddress })
                    })
                ])

                if (tokenInventoryResponse) {
                    setTokenInventoryData(tokenInventoryResponse)

                    setTitle(
                        `A total of ${tokenInventoryResponse.totalItems.toLocaleString()} token${
                            tokenInventoryResponse.totalItems === 1 ? '' : 's'
                        } found`
                    )
                    setTotalPages(tokenInventoryResponse.totalPages)
                }

                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [address, userAddress, network, page])

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    <TableHeader title={title} page={page} limit={25} totalPages={totalPages} />
                    <TokenInventoryTable data={tokenInventoryData?.items} setActiveTab={setActiveTab} />
                    {tokenInventoryData?.totalItems > 0 && (
                        <TableFooterWithoutLimit page={page} limit={25} totalPages={totalPages} />
                    )}
                </>
            )}
        </div>
    )
}

module.exports = { TokenInventory }
